module.exports = "\nVítejte v intranetu!\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/home/home.component.html
// module id = 458
// module chunks = 1